import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const ROLE_LABELS = { user: 'Utente', certifier: 'Certificatore', admin: 'Admin' };
const ROLE_COLORS = { user: 'badge-gray', certifier: 'badge-blue', admin: 'badge-amber' };

export default function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    axios.get('/api/admin/users').then(r => setUsers(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const changeRole = async (userId, newRole) => {
    try {
      await axios.put(`/api/admin/users/${userId}/role`, { role: newRole });
      toast.success('Ruolo aggiornato');
      load();
    } catch {
      toast.error('Errore nel cambio ruolo');
    }
  };

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">Gestione utenti</span>
        <span style={{ fontSize: 13, color: '#9B9A92' }}>{users.length} utenti registrati</span>
      </div>
      <div className="page-content">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Azienda</th>
                <th>Ruolo</th>
                <th>Email verificata</th>
                <th>Registrato il</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} style={{ textAlign: 'center', padding: 32, color: '#9B9A92' }}>Caricamento...</td></tr>
              ) : users.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 500 }}>{u.email}</td>
                  <td style={{ color: '#5C5B55' }}>{u.company?.name || '—'}</td>
                  <td><span className={`badge ${ROLE_COLORS[u.role]}`}>{ROLE_LABELS[u.role]}</span></td>
                  <td style={{ color: u.emailVerified ? '#1D9E75' : '#9B9A92' }}>{u.emailVerified ? '✓ Verificata' : '⏳ In attesa'}</td>
                  <td style={{ color: '#9B9A92' }}>{new Date(u.createdAt).toLocaleDateString('it-IT')}</td>
                  <td>
                    <select
                      value={u.role}
                      onChange={e => changeRole(u.id, e.target.value)}
                      style={{ fontSize: 12, padding: '4px 8px', border: '1px solid #E0DED6', borderRadius: 6, background: 'white', cursor: 'pointer' }}
                    >
                      <option value="user">Utente</option>
                      <option value="certifier">Certificatore</option>
                      <option value="admin">Admin</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
